import {
  createRouter,
  createWebHashHistory,
  type RouteRecordRaw
} from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useFavoriteStore } from "@/stores/favorite";

const publicNames = new Set(["home", "login", "terms", "privacy", "extension"]);

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("@/views/Terms.vue")
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("@/views/Privacy.vue")
  },
  {
    path: "/extension",
    name: "extension",
    component: () => import("@/views/Extension.vue")
  },
  {
    path: "/admin/login",
    name: "login",
    component: () => import("@/views/Login.vue")
  },
  {
    path: "/admin/logout",
    name: "logout",
    redirect: () => {
      const auth = useAuthStore();
      const favorite = useFavoriteStore();
      auth.logout();
      favorite.setEditMode(false);
      return "/admin/login";
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  auth.clearIfExpired();

  if (typeof to.name === "string" && publicNames.has(to.name)) {
    return true;
  }
  if (!auth.isLoggedIn) {
    return "/admin/login";
  }
  return true;
});

export default router;
